import React, { useState, useEffect, memo } from 'react';
import { useFormikContext } from 'formik';
import ToggleSelect from '../../../../common/components/ToggleSelect/ToggleSelect';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton';
import _ from 'lodash';
import { navigate } from 'gatsby';
import {
  updateLAPPropertyAPI,
  getLAPPropertyAPI
} from '../../../../common/constants/api';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import PopUp from '../../../../common/components/PopUp/PopUp';

let data = [
  {
    displayName: 'Self Use',
    id: 'SELF_USE'
  },
  {
    displayName: 'Given for Rent',
    id: 'GIVEN_FOR_RENT'
  },
  {
    displayName: 'Vacant',
    id: 'VACANT'
  }
];
const PropertyPossessionType = () => {
  const {
    values,
    errors,
    handleSubmit,
    isSubmitting,
    setFieldValue
  } = useFormikContext();
  const [showSuuccess, setShowSuccess] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [goto, setGoTo] = useState(false);
  const [dontClose, setDontClose] = useState(false);

  async function upDatePropPossessionType() {
    setType('loading');
    setText('Loading Please Wait...');
    setShow(true);
    await updateLAPPropertyAPI(getApplicantionInfo().leadId, {
      possessionType: values?.propertyPossessionID
    })
      .then(res => {
        setDontClose(true);
        setGoTo(true);
        setType('success');
        setText('Application Submitted Successfully!');
        setShow(true);
      })
      .catch(error => {
        setShow(false);
      });
  }
  useEffect(() => {
    setType('loading');
    setText('Loading Please Wait...');
    setShow(true);
    getLAPPropertyAPI(getApplicantionInfo().leadId)
      .then(res => {
        setShow(false);
        setFieldValue('propertyPossessionID', res?.possessionType);
      })
      .catch(err => {
        setShow(false);
      });
  }, []);
  return (
    <React.Fragment>
      <div className="px-5">
        <p className="pt-2 text-black-850 text-base font-medium font-roboto">
          Property Possession Type
        </p>
        <div className="md:flex md:flex-wrap md:justify-start ">
          {data &&
            data.map(each => {
              return (
                <div key={each?.id}>
                  <div className="flex my-4 hidden md:block">
                    <ToggleSelect
                      name={each?.displayName}
                      value={each?.displayName}
                      checked={values.propertyPossessionID === each?.id}
                      onChange={e => {
                        setFieldValue('propertyPossessionID', each?.id);
                      }}
                      addClasses="cursor-pointer hover:bg-green-100 hover:border-green-1000 mb-8"
                      containerStyle={{
                        width: '7.5rem',
                        height: '100px',
                        marginRight: '20px'
                      }}
                      nameDisplay={each?.displayName}
                      namingStyle={{
                        paddingTop: '40px',
                        color:
                          values.propertyPossessionID === each?.id
                            ? '#00ACB8'
                            : '#7B8C9B'
                      }}
                    />
                  </div>

                  <div className="block w-full md:hidden flex my-3">
                    <div className="font-robot font-normal text-base text-grey-2000">
                      {each.displayName}
                    </div>
                    <div className="ml-auto">
                      <RadioButton
                        name={each?.displayName}
                        checked={values.propertyPossessionID === each?.id}
                        onChange={e => {
                          setFieldValue('propertyPossessionID', each?.id);
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        <div className="mt-12">
          <button
            onClick={() =>
              values?.propertyPossessionID ? upDatePropPossessionType() : null
            }
            type="button"
            disabled={!_.isEmpty(errors)}
            className="submitButton font-roboto text-white text-base w-48 "
          >
            SUBMIT
          </button>
        </div>
      </div>
      <PopUp
        type={type}
        text={text}
        setShow={setShow}
        show={show}
        dontClose={dontClose}
        goto={goto}
      />
    </React.Fragment>
  );
};

export default memo(withErrorHandler(PropertyPossessionType));
